import { CookieInfoApi, PublicConsentState } from 'src/app/models/api.model'
import { RuntimeEnvType } from 'src/app/models/app-config.model'
import { AppInitializerService } from '../app-initializer.service'
import { ConsentModalService } from '../consent-modal.service'
import { CookieConsent } from 'src/app/models/consent-data.model'
import { SupportedLanguages } from 'src/app/models/app-translations.model'
import { ConsentAltBox } from 'src/app/components/consent-alt-box/consent-alt-box.component'
import { ConsentAltConfiguration, ConsentBoxAltType } from 'src/app/components/consent-alt-box/consent-alt-box.model'
import { Observable, filter } from 'rxjs'

export class CookieInfoApiService {
  private static instance: CookieInfoApiService
  private readonly appInitializerService: AppInitializerService
  private readonly consentModalService: ConsentModalService

  private constructor() {
    this.appInitializerService = AppInitializerService.getInstance()
    this.consentModalService = ConsentModalService.getInstance()
  }

  static getInstance(): CookieInfoApiService {
    if (CookieInfoApiService.instance === undefined) {
      CookieInfoApiService.instance = new CookieInfoApiService()
    }

    return CookieInfoApiService.instance
  }

  getInitialPublicApi(): CookieInfoApi {
    return {
      setRuntimeEnvType: (type: RuntimeEnvType): void => {
        this.appInitializerService.setRuntimeEnvType(type)
      },
      setConsentData: (data: CookieConsent): void => {
        this.appInitializerService.setConsentData(data)
      },
      setSaveLogApiUrl: (url: string): void => {
        this.appInitializerService.setSaveLogApiUrl(url)
      },
      setInterfaceLang: (lang: SupportedLanguages): void => {
        this.appInitializerService.setInterfaceLang(lang)
      },
      getAlternative: (type: ConsentBoxAltType, configuration: ConsentAltConfiguration | undefined): HTMLElement => {
        return this.getAlternativeContent(type, configuration)
      },
      setIntegrationWithGTM: (delay?: number) => {
        this.appInitializerService.setIntegrationWithGTM(delay)
      },
      displayStickyTrigger: (visible: boolean) => {
        this.appInitializerService.displayStickyTrigger(visible)
      },
      displayFirstStepRejectAllButton: (show: boolean) => {
        this.appInitializerService.displayFirstStepRejectAllButton(show)
      },
      displayCloseButton: (show: boolean) => {
        this.appInitializerService.displayCloseButton(show)
      },
      addCustomCssClass: (className: string) => {
        this.appInitializerService.addCustomCssClass(className)
      },
      showModal: () => {
        this.consentModalService.showModal()
      },
      getConsentChangeSubscription: () => {
        return this.appInitializerService
          .getPublicConsentDataSubscription()
          .pipe(filter(data => data !== null)) as Observable<PublicConsentState>
      },
      run: () => {
        this.appInitializerService.init()
      },
      isConsentAccepted: (consentTag: string) => {
        return this.appInitializerService.checkConsent(consentTag)
      }
    }
  }

  private getAlternativeContent(
    type: ConsentBoxAltType,
    configuration: ConsentAltConfiguration | undefined
  ): HTMLElement {
    const altBox = new ConsentAltBox(type, configuration)

    return altBox.getHTMLContent()
  }
}
